module.exports = __webpack_public_path__ + "img/htkj_08.5792efc7.jpg";